import { scrollUnlock, scrollLock } from '@helpers/scroll'

export function toggleMobileCatalogPanel() {
  const [panel] = document.getElementsByClassName('js-mobile-catalog-panel')
  const [button] = document.getElementsByClassName('js-mobile-catalog-button')
  const [backdrop] = document.getElementsByClassName('js-mobile-catalog-backdrop')

  if (!panel || !button) return

  const closes = document.getElementsByClassName('js-mobile-catalog-close')
  const backs = document.getElementsByClassName('js-mobile-catalog-back')
  const items = document.getElementsByClassName('js-mobile-catalog-item')
  const subscreens = document.getElementsByClassName('js-mobile-catalog-subscreen')

  function hideAllSubscreens() {
    for (const s of subscreens) s.classList.remove('is-active')
  }

  function openPanel() {
    panel.classList.add('is-active')
    if (backdrop) backdrop.classList.add('is-active')
    scrollLock()
  }

  function closePanel() {
    panel.classList.remove('is-active')
    if (backdrop) backdrop.classList.remove('is-active')
    hideAllSubscreens()
    scrollUnlock()
  }

  function openSubscreen(catId) {
    hideAllSubscreens()
    for (const s of subscreens) {
      if (s.dataset.catId === String(catId)) {
        s.classList.add('is-active')
        s.scrollTop = 0
        return true
      }
    }
    return false
  }

  button.addEventListener('click', openPanel)
  for (const c of closes) c.addEventListener('click', closePanel)
  for (const b of backs) b.addEventListener('click', hideAllSubscreens)
  if (backdrop) backdrop.addEventListener('click', closePanel)

 
  for (const item of items) {
    item.addEventListener('click', (e) => {
      const catId = item.dataset.catId
      const hasSubscreen = openSubscreen(catId)
      if (hasSubscreen) e.preventDefault()
    })
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    if (!panel.classList.contains('is-active')) return

    const anySubOpen = Array.from(subscreens).some((s) => s.classList.contains('is-active'))
    if (anySubOpen) hideAllSubscreens()
    else closePanel()
  })
}
